import type { ReactNode } from 'react';
import { MotionFadeUp } from './motion';

type AlertTone = 'info' | 'success' | 'warning' | 'error';

interface AlertProps {
  children: ReactNode;
  title?: string;
  tone?: AlertTone;
  onDismiss?: () => void;
  dismissLabel?: string;
}

export function Alert({ children, title, tone = 'info', onDismiss, dismissLabel = 'Dismiss' }: AlertProps) {
  return (
    <MotionFadeUp className={`ui-alert ui-alert--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <div className="ui-alertContent">
        {title && <strong className="ui-alertTitle">{title}</strong>}
        <div>{children}</div>
      </div>
      {onDismiss && <button type="button" className="ui-alertDismiss" onClick={onDismiss} aria-label={dismissLabel}>×</button>}
    </MotionFadeUp>
  );
}
